import { render, staticRenderFns } from "./createShipment.vue?vue&type=template&id=784885e4&"
import script from "./createShipment.vue?vue&type=script&lang=js&"
export * from "./createShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports